import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Protected({ children }) {
    const navigate = useNavigate();
    const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login');
        }
    }, [isAuthenticated, navigate]);

    return isAuthenticated ? children : null;
}

export default Protected;